/**
 * Vista de login del Promotor Digital.
 * Si NO hay device-token (no canjeó su link de acceso), avisa que abra el
 * link que le pasó su operador.
 */

import { t } from '../languages.js';
import { escapeHtml } from '../systems/escape-html.js';

export function renderLogin({ tieneDispositivo, mensajeError, emailInicial, onLogin, onOlvido }) {
    const el = document.createElement('div');
    el.className = 'login-box';

    if (!tieneDispositivo) {
        // Sin device-token: o nunca canjeó (sinAcceso) o el admin regeneró el link y
        // lo revocó (mensajeError = "tu enlace ya no es válido, pedí uno nuevo").
        el.innerHTML = `
            <div style="text-align:center;">
                <h1 style="margin:0 0 8px;">${t('login.titulo')}</h1>
                <p style="color:var(--text-dim);">${mensajeError || t('login.sinAcceso')}</p>
            </div>`;
        return el;
    }

    el.innerHTML = `
        <div style="text-align:center; margin-bottom:8px;">
            <h1 style="margin:0 0 4px;">${t('login.titulo')}</h1>
            <p style="color:var(--text-dim); margin:0;">${t('login.subtitulo')}</p>
        </div>
        <input type="email" id="pm-email" placeholder="${t('login.correo')}" autocomplete="username" inputmode="email" value="${escapeHtml(emailInicial)}">
        <input type="password" id="pm-pass" placeholder="${t('login.password')}" autocomplete="current-password">
        <div class="error" id="pm-error">${mensajeError || ''}</div>
        <button class="btn btn-install" id="pm-entrar">${t('login.entrar')}</button>
        <button class="btn" id="pm-olvido" style="margin-top:8px; background:transparent; color:var(--text-dim);">${t('login.olvido')}</button>`;

    const emailEl = el.querySelector('#pm-email');
    const passEl = el.querySelector('#pm-pass');
    const errEl = el.querySelector('#pm-error');
    const btn = el.querySelector('#pm-entrar');
    const olvidoBtn = el.querySelector('#pm-olvido');

    let enProgreso = false;
    async function intentar() {
        if (enProgreso) return;
        const email = (emailEl.value || '').trim();
        const password = passEl.value || '';
        if (!email || !password) {
            errEl.textContent = t('login.completar');
            return;
        }
        enProgreso = true;
        btn.disabled = true;
        btn.textContent = t('login.entrando');
        errEl.textContent = '';
        try {
            const error = await onLogin(email, password);
            if (error) {
                errEl.textContent = error;
                // Tras un error de credenciales, destacar la salida: el promotor que no
                // recuerda su contraseña tiene el camino a un toque, no escondido.
                olvidoBtn.style.color = 'var(--accent-blue, #3b82f6)';
                olvidoBtn.style.fontWeight = '600';
            }
        } finally {
            enProgreso = false;
            btn.disabled = false;
            btn.textContent = t('login.entrar');
        }
    }

    btn.addEventListener('click', intentar);
    // Enter en cualquiera de los dos campos intenta el login (no solo en la seña):
    // si el email viene prefilled, el promotor teclea la seña y da Enter ahí; si
    // corrige el email, Enter desde el correo también entra.
    emailEl.addEventListener('keydown', e => {
        if (e.key === 'Enter') intentar();
    });
    passEl.addEventListener('keydown', e => {
        if (e.key === 'Enter') intentar();
    });
    if (onOlvido) olvidoBtn.addEventListener('click', () => onOlvido());

    // Con el correo recordado, el foco va directo a la seña (el promotor solo
    // teclea su contraseña). Sin correo previo, foco al correo. requestAnimationFrame
    // porque el elemento aún no está montado en el DOM al retornar.
    requestAnimationFrame(() => (emailEl.value ? passEl : emailEl).focus());

    return el;
}
